module.exports = __webpack_public_path__ + "static/media/everyday_digital_footy2024.bb6ec050.webp";